import memoize from 'memoizee';

import { sendSentryClientError } from 'shared/lib';
import {
  isAddressDataHasHouse,
  isMilitaryAddress,
  prepareAddressPartsForDadataSuggest,
} from 'shared/lib/addressFields';
import { getFullAddressesAutocomplete } from 'src/client/shared/api/daData';

import { isAddressValidFromStreetSuggestions } from './isAddressValidFromStreetSuggestions';

const getFullAddressesAutocompleteCached = memoize((query: string) => getFullAddressesAutocomplete(query), {
  promise: true,
  maxAge: 1000 * 60, // 1 минута
});

export const checkWorkAddress = async (address: string) => {
  const [mainPart, secondPart] = prepareAddressPartsForDadataSuggest(address);

  try {
    const fit = mainPart ? await getFullAddressesAutocompleteCached(mainPart) : null;

    // если запрос dadata по основному адресу упал и вернул undefined, то удаляем его из кэша,
    // чтобы при следующей проверке попытаться запросить данные снова
    if (typeof fit === 'undefined') {
      getFullAddressesAutocompleteCached.delete(mainPart);
    }

    if (!fit) {
      return false;
    }

    return Boolean(
      isAddressDataHasHouse(fit.data) ||
        isAddressValidFromStreetSuggestions([{ ...fit, value: mainPart }]) ||
        isMilitaryAddress(secondPart, fit.data),
    );
  } catch (error) {
    sendSentryClientError(error as Error, { placement: 'checkWorkAddress', address });
    return false;
  }
};
